
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3FCPe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TeamProfileCardInner", () => $e9a6bdff81a70841$export$25379cf72e576e0e);
$parcel$export(module.exports, "default", () => $e9a6bdff81a70841$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6ZAYN = parcelRequire("6ZAYN");

var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $14XJw = parcelRequire("14XJw");

var $90yGq = parcelRequire("90yGq");

var $cZpsT = parcelRequire("cZpsT");

var $lVJAU = parcelRequire("lVJAU");

var $7I2zi = parcelRequire("7I2zi");

var $f5xXn = parcelRequire("f5xXn");

var $9l5Jv = parcelRequire("9l5Jv");
const $e9a6bdff81a70841$export$25379cf72e576e0e = ({ children: children, onRedirect: onRedirect, position: position, shouldRenderToParent: shouldRenderToParent, teamId: teamId, trigger: trigger, triggerLinkType: triggerLinkType, userId: userId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onUserClick = (0, $5uXOq.useCallback)((accountId)=>onRedirect((0, $7I2zi.generateUserLink)(accountId)), [
        onRedirect
    ]);
    const teamProfileUrl = `/jira/people/team/${teamId}`;
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { profileClient: profileClient } = (0, $9l5Jv.useProfileClient)();
    if (!profileClient) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZAYN.default), {
        teamId: teamId,
        orgId: orgId,
        viewingUserId: userId,
        resourceClient: profileClient,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: teamProfileUrl,
        viewProfileOnClick: ()=>onRedirect(teamProfileUrl),
        generateUserLink: (0, $7I2zi.generateUserLink),
        onUserClick: onUserClick,
        position: position,
        shouldRenderToParent: shouldRenderToParent,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- FYI: Typed as "any" in platform component
        addFlag: (flag)=>{
            const flagId = (0, $7HGHK.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.team-profilecard.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...flagProps
                    })
            });
        }
    }, children);
};
const $e9a6bdff81a70841$var$TeamProfileCardNext = (props)=>{
    const { children: children, teamId: teamId } = props;
    const userId = (0, $90yGq.useAccountId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    if (!teamId || isAnonymous || !userId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5xXn.ProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9a6bdff81a70841$export$25379cf72e576e0e, {
        ...props,
        userId: userId,
        onRedirect: push
    }));
};
var $e9a6bdff81a70841$export$2e2bcd8739ae039 = $e9a6bdff81a70841$var$TeamProfileCardNext;

});
parcelRegister("6ZAYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $64a6b0ab2e2c89bb$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $bNH3v = parcelRequire("bNH3v");
var $64a6b0ab2e2c89bb$export$2e2bcd8739ae039 = (0, $bNH3v.default);

});
parcelRegister("bNH3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a787b363306082b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $2keUK = parcelRequire("2keUK");

var $kmSlU = parcelRequire("kmSlU");
var $k4NZN = parcelRequire("k4NZN");

var $hFKXd = parcelRequire("hFKXd");

var $bRHJ4 = parcelRequire("bRHJ4");

var $e65Lk = parcelRequire("e65Lk");

var $1wToE = parcelRequire("1wToE");

var $7nT3L = parcelRequire("7nT3L");

var $dUNOS = parcelRequire("dUNOS");

var $lL6Xv = parcelRequire("lL6Xv");

var $bKdCv = parcelRequire("bKdCv");


var $f0Crb = parcelRequire("f0Crb");

var $pnR8N = parcelRequire("pnR8N");

var $iDg8T = parcelRequire("iDg8T");

var $cPjSa = parcelRequire("cPjSa");
class $2a787b363306082b$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $7nT3L.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $dUNOS.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pnR8N.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bRHJ4.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $1wToE.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $hFKXd.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $lL6Xv.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $f0Crb.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $f0Crb.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $bKdCv.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $lL6Xv.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $lL6Xv.cardTriggered)('team', 'hover', this.props.teamId));
            }
            this.showProfilecard((0, $ebb4ffc4551ca474$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $ebb4ffc4551ca474$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $lL6Xv.cardTriggered)('team', 'click', this.props.teamId));
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $ebb4ffc4551ca474$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $lL6Xv.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cPjSa.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iDg8T.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmSlU.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $k4NZN.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    (0, $hFKXd.fg)('enable_team_profilecard_toggletip_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e65Lk.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $dUNOS.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
var $2a787b363306082b$export$2e2bcd8739ae039 = (0, $2keUK.default)()((0, $8RXs9.default)($2a787b363306082b$export$f811dc569217c959));

});
parcelRegister("kmSlU", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $6fa95ca76ce14127$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $6fa95ca76ce14127$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("cp7vs")));

});
parcelRegister("cp7vs", function(module, exports) {

let $907da46d8ec19d0e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $907da46d8ec19d0e$var$load("4X3wS"),
    $907da46d8ec19d0e$var$load("hSQJ5"),
    $907da46d8ec19d0e$var$load("aCh9P"),
    $907da46d8ec19d0e$var$load("bxxT5"),
    $907da46d8ec19d0e$var$load("7C9cO")
]).then(()=>parcelRequire('5pCAN'));

});


parcelRegister("k4NZN", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $17b7f09b38b36008$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $17b7f09b38b36008$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $17b7f09b38b36008$export$7a1fc1a1b0477464);
var $17b7f09b38b36008$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $17b7f09b38b36008$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $17b7f09b38b36008$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($17b7f09b38b36008$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("7nT3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ca68a0fed5f06b$export$2e2bcd8739ae039);
const $a3ca68a0fed5f06b$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $a3ca68a0fed5f06b$export$2e2bcd8739ae039 = $a3ca68a0fed5f06b$var$filterActions;

});

parcelRegister("dUNOS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c8c0b210663422$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $01c8c0b210663422$var$messages = (0, $7VHMR.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $01c8c0b210663422$export$2e2bcd8739ae039 = $01c8c0b210663422$var$messages;

});

parcelRegister("lL6Xv", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3674b041c85fc0cd$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3674b041c85fc0cd$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3674b041c85fc0cd$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3674b041c85fc0cd$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3674b041c85fc0cd$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3674b041c85fc0cd$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3674b041c85fc0cd$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3674b041c85fc0cd$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3674b041c85fc0cd$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3674b041c85fc0cd$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3674b041c85fc0cd$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3674b041c85fc0cd$export$a9f8c9f412cf5664);

var $f0Crb = parcelRequire("f0Crb");
/** Below lines are copied from teams common analytics */ const $3674b041c85fc0cd$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3674b041c85fc0cd$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3674b041c85fc0cd$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3674b041c85fc0cd$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3674b041c85fc0cd$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3674b041c85fc0cd$var$TEAM_SUBJECT = 'teamProfileCard';
const $3674b041c85fc0cd$var$USER_SUBJECT = 'profilecard';
const $3674b041c85fc0cd$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $3674b041c85fc0cd$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $f0Crb.getPageTime)())
        }
    });
const $3674b041c85fc0cd$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3674b041c85fc0cd$var$USER_SUBJECT;
        case 'team':
            return $3674b041c85fc0cd$var$TEAM_SUBJECT;
        case 'agent':
            return $3674b041c85fc0cd$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3674b041c85fc0cd$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $3674b041c85fc0cd$var$createEvent('ui', 'triggered', $3674b041c85fc0cd$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $3674b041c85fc0cd$export$c9b0e37b229a297b = (action, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$TEAM_SUBJECT, 'request', attributes);
const $3674b041c85fc0cd$export$12dae48763368ac9 = (action, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$USER_SUBJECT, 'request', attributes);
const $3674b041c85fc0cd$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'rendered', $3674b041c85fc0cd$var$getActionSubject(type), actionSubjectId, attributes);
const $3674b041c85fc0cd$export$fdcd134fbeb1f921 = (type, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$getActionSubject(type), 'action', attributes);
const $3674b041c85fc0cd$export$93260987012593be = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$USER_SUBJECT, 'reportingLines', attributes);
const $3674b041c85fc0cd$export$79befd155063a6a7 = (type, attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$getActionSubject(type), 'moreActions', attributes);
const $3674b041c85fc0cd$export$2703289b35687fde = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'avatar', attributes);
const $3674b041c85fc0cd$export$b4411a7661cf2d3f = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3674b041c85fc0cd$export$c86679da702d560e = (attributes)=>$3674b041c85fc0cd$var$createEvent('ui', 'clicked', $3674b041c85fc0cd$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3674b041c85fc0cd$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$3674b041c85fc0cd$var$createEvent('operational', action, $3674b041c85fc0cd$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("f0Crb", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $3054df903dd8b007$export$e9faea7c41053334);
const $3054df903dd8b007$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $3054df903dd8b007$var$performanceAvailable = $3054df903dd8b007$var$isPerformanceAvailable();
const $3054df903dd8b007$var$initialPageTime = Date.now();
const $3054df903dd8b007$export$e9faea7c41053334 = ()=>{
    if ($3054df903dd8b007$var$performanceAvailable) return performance.now();
    return Date.now() - $3054df903dd8b007$var$initialPageTime;
};

});


parcelRegister("bKdCv", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $8b0bfb88bde3a573$export$eddcd8a5b7e09991);
const $8b0bfb88bde3a573$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

const $ebb4ffc4551ca474$export$5b956b542f1bc1b3 = 800;
const $ebb4ffc4551ca474$export$89a9f35a94d7f196 = 200;

parcelRegister("pnR8N", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $5f28cfe64694f240$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $5f28cfe64694f240$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $5f28cfe64694f240$export$2e2bcd8739ae039 = $5f28cfe64694f240$export$e926676385687eaf;

});

parcelRegister("iDg8T", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $50d444203cec27fb$export$82a49d896f41ca78);

var $5uXOq = parcelRequire("5uXOq");

const $50d444203cec27fb$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6vTuP")));

});
parcelRegister("6vTuP", function(module, exports) {

let $4be0afb3a22029ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4be0afb3a22029ab$var$load("kDrEE").then(()=>parcelRequire('eNpoA'));

});


parcelRegister("cPjSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $038147bc92883eb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dyckQ = parcelRequire("dyckQ");

var $gH8dE = parcelRequire("gH8dE");

var $lL6Xv = parcelRequire("lL6Xv");
var $038147bc92883eb9$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $lL6Xv.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gH8dE.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gH8dE.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gH8dE.CardContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gH8dE.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dyckQ.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("gH8dE", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $e29845700dcd5f8b$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $e29845700dcd5f8b$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $e29845700dcd5f8b$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $e29845700dcd5f8b$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $e29845700dcd5f8b$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $e29845700dcd5f8b$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $e29845700dcd5f8b$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $e29845700dcd5f8b$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $e29845700dcd5f8b$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $e29845700dcd5f8b$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $e29845700dcd5f8b$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $e29845700dcd5f8b$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $e29845700dcd5f8b$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $e29845700dcd5f8b$export$71bcd744fda975e5);
/* TeamCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bGNZj = parcelRequire("bGNZj");

var $1pATn = parcelRequire("1pATn");

var $hFKXd = parcelRequire("hFKXd");

var $5JBkS = parcelRequire("5JBkS");
var $13umX = parcelRequire("13umX");


var $1wToE = parcelRequire("1wToE");

var $42CYN = parcelRequire("42CYN");

var $bVk6D = parcelRequire("bVk6D");

var $bWGt6 = parcelRequire("bWGt6");
function $e29845700dcd5f8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e29845700dcd5f8b$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    teamforbiddenerrorstatewrapper: "_1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    teamname: "_11c8lodh _1reo15vq _18m915vq _1p1dglyw _c71lckbl _1e0ccj1k",
    membercount: "_syaz1wmz _19pk1b66",
    avatarsection: "_19pkpxbi _18u01i6y",
    descriptionwrapper: "_19pkpxbi _4cvr1h6o _1e0c1txw",
    description: "_1reo15vq _18m915vq _c71l1wqb _1e0ccj1k",
    actionbuttons: "_1bsb1osq _1e0c1txw _1bah1yb4 _19pk1ejb _2hwx10v4 _otyridpf _18u0x0bf",
    wrappedbutton: "_i0dlidpf _16jlkb7n _18u0u2gc",
    morebutton: "_18u0u2gc",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    accesslocksvgwrapper: "_otyr1ejb"
};
const $e29845700dcd5f8b$export$a443be8291b92497 = ()=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.cardtriggerwrapper)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$CardTriggerWrapperLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$CardTriggerWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q14"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $e29845700dcd5f8b$export$6aa22a823032b784 = ({ testId: testId, children: children })=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$CardWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q13"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $42CYN.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $1wToE.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: '320px',
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $e29845700dcd5f8b$export$66ecf3d3b7b1c016 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.teamforbiddenerrorstatewrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$TeamForbiddenErrorStateWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$TeamForbiddenErrorStateWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q12"
})({
    name: "14xkrbi",
    styles: "width:320px;position:relative"
});
const $e29845700dcd5f8b$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? isLoading || !image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bVk6D.CoverImage), {
        alt: label || '',
        src: image
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$CardHeaderLegacy, {
        image: image,
        isLoading: isLoading
    }); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$CardHeaderLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q11"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $dbda9f692ace54dd$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $42CYN.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:128px;");
const $e29845700dcd5f8b$export$64ef9b8c11710c47 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.cardcontent),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$CardContentLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q10"
})({
    name: "1rjz27l",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-300, 24px);min-height:104px"
});
const $e29845700dcd5f8b$export$8fe6f0aed18a58c7 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? (0, $hFKXd.fg)('enable_profilecard_h2tag_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.teamname),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1pATn.default), {
            size: "medium",
            as: "h2",
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.teamname),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$TeamNameLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$TeamNameLegacy = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e14jp07q9"
})({
    name: "1ms0od4",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical"
});
const $e29845700dcd5f8b$export$1cbd03a20253b620 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.membercount),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$MemberCountLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$MemberCountLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q8"
})({
    color: `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $e29845700dcd5f8b$export$82a6f3ee677bdbfe = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.avatarsection),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$AvatarSectionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$AvatarSectionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q7"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $e29845700dcd5f8b$export$2bf1f2b0d31b60fc = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.descriptionwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$DescriptionWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$DescriptionWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q6"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $e29845700dcd5f8b$export$393edc798c47379d = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.description),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $13umX.default), {
            maxLines: 3,
            ...props
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$DescriptionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$DescriptionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e14jp07q5"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $e29845700dcd5f8b$export$88c65d2d98aab183 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.actionbuttons),
        backgroundColor: "elevation.surface.overlay",
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$ActionButtonsLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$ActionButtonsLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q4"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $e29845700dcd5f8b$export$44e087c32db6077d = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.wrappedbutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$WrappedButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$WrappedButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q3"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $e29845700dcd5f8b$export$7f94856880993f27 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.morebutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$MoreButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$MoreButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q2"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $e29845700dcd5f8b$export$43a792a870d28db2 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.loadingwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$LoadingWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$LoadingWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q1"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $e29845700dcd5f8b$export$71bcd744fda975e5 = (props)=>(0, $hFKXd.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        xcss: (0, $bGNZj.cx)($e29845700dcd5f8b$var$styles.accesslocksvgwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e29845700dcd5f8b$var$AccessLockSVGWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $e29845700dcd5f8b$var$AccessLockSVGWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q0"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
});

});
var $dbda9f692ace54dd$exports = {};

$parcel$export($dbda9f692ace54dd$exports, "R50", () => $dbda9f692ace54dd$export$4b84fd0e2c617bd);
$parcel$export($dbda9f692ace54dd$exports, "R75", () => $dbda9f692ace54dd$export$b34b069eff244586);
$parcel$export($dbda9f692ace54dd$exports, "R100", () => $dbda9f692ace54dd$export$be802dd0d8b57f35);
$parcel$export($dbda9f692ace54dd$exports, "R200", () => $dbda9f692ace54dd$export$60847d42f9da92a6);
$parcel$export($dbda9f692ace54dd$exports, "R300", () => $dbda9f692ace54dd$export$4a7404f376229999);
$parcel$export($dbda9f692ace54dd$exports, "R400", () => $dbda9f692ace54dd$export$2010d0fb4295b346);
$parcel$export($dbda9f692ace54dd$exports, "R500", () => $dbda9f692ace54dd$export$2837b5a1a71d5c02);
$parcel$export($dbda9f692ace54dd$exports, "Y50", () => $dbda9f692ace54dd$export$8d9596b529bbb9cf);
$parcel$export($dbda9f692ace54dd$exports, "Y75", () => $dbda9f692ace54dd$export$41060a744ab0b7ae);
$parcel$export($dbda9f692ace54dd$exports, "Y100", () => $dbda9f692ace54dd$export$1cc05bbbf340e559);
$parcel$export($dbda9f692ace54dd$exports, "Y200", () => $dbda9f692ace54dd$export$5aae31392d72caaa);
$parcel$export($dbda9f692ace54dd$exports, "Y300", () => $dbda9f692ace54dd$export$c6930421db9fa514);
$parcel$export($dbda9f692ace54dd$exports, "Y400", () => $dbda9f692ace54dd$export$59619663aa6500fb);
$parcel$export($dbda9f692ace54dd$exports, "Y500", () => $dbda9f692ace54dd$export$874739ea9e379ab6);
$parcel$export($dbda9f692ace54dd$exports, "G50", () => $dbda9f692ace54dd$export$8a6341c32b6a3ee6);
$parcel$export($dbda9f692ace54dd$exports, "G75", () => $dbda9f692ace54dd$export$69a3bf21b9686c2b);
$parcel$export($dbda9f692ace54dd$exports, "G100", () => $dbda9f692ace54dd$export$afbce1382ec95f73);
$parcel$export($dbda9f692ace54dd$exports, "G200", () => $dbda9f692ace54dd$export$747d86715d4175de);
$parcel$export($dbda9f692ace54dd$exports, "G300", () => $dbda9f692ace54dd$export$940e1f69e873f202);
$parcel$export($dbda9f692ace54dd$exports, "G400", () => $dbda9f692ace54dd$export$a49394138f7b8e85);
$parcel$export($dbda9f692ace54dd$exports, "G500", () => $dbda9f692ace54dd$export$6fa04827ac68a4fb);
$parcel$export($dbda9f692ace54dd$exports, "B50", () => $dbda9f692ace54dd$export$226de0355ed012f8);
$parcel$export($dbda9f692ace54dd$exports, "B75", () => $dbda9f692ace54dd$export$8c13c2ee36917869);
$parcel$export($dbda9f692ace54dd$exports, "B100", () => $dbda9f692ace54dd$export$ecfc1dff386a3e7a);
$parcel$export($dbda9f692ace54dd$exports, "B200", () => $dbda9f692ace54dd$export$215b7063051591f1);
$parcel$export($dbda9f692ace54dd$exports, "B300", () => $dbda9f692ace54dd$export$e62e8919cca44969);
$parcel$export($dbda9f692ace54dd$exports, "B400", () => $dbda9f692ace54dd$export$b3de0ae08da2ce64);
$parcel$export($dbda9f692ace54dd$exports, "B500", () => $dbda9f692ace54dd$export$a6ee3d71bc067634);
$parcel$export($dbda9f692ace54dd$exports, "B600", () => $dbda9f692ace54dd$export$67f15409e87642a1);
$parcel$export($dbda9f692ace54dd$exports, "B700", () => $dbda9f692ace54dd$export$f0539dbc42dbb067);
$parcel$export($dbda9f692ace54dd$exports, "P50", () => $dbda9f692ace54dd$export$363e4475840015bb);
$parcel$export($dbda9f692ace54dd$exports, "P75", () => $dbda9f692ace54dd$export$4b0a4417ed59760f);
$parcel$export($dbda9f692ace54dd$exports, "P100", () => $dbda9f692ace54dd$export$6011520a64d9a187);
$parcel$export($dbda9f692ace54dd$exports, "P200", () => $dbda9f692ace54dd$export$a7175d4e9206bc80);
$parcel$export($dbda9f692ace54dd$exports, "P300", () => $dbda9f692ace54dd$export$b48405b95304b5a1);
$parcel$export($dbda9f692ace54dd$exports, "P400", () => $dbda9f692ace54dd$export$c71e4279dd54a18d);
$parcel$export($dbda9f692ace54dd$exports, "P500", () => $dbda9f692ace54dd$export$147899de772240ec);
$parcel$export($dbda9f692ace54dd$exports, "T50", () => $dbda9f692ace54dd$export$2cf711fe14c66f06);
$parcel$export($dbda9f692ace54dd$exports, "T75", () => $dbda9f692ace54dd$export$7a8f4d33f6f9772c);
$parcel$export($dbda9f692ace54dd$exports, "T100", () => $dbda9f692ace54dd$export$776c9c497ef08533);
$parcel$export($dbda9f692ace54dd$exports, "T200", () => $dbda9f692ace54dd$export$69cb3ca10c1e330e);
$parcel$export($dbda9f692ace54dd$exports, "T300", () => $dbda9f692ace54dd$export$9dc1ef0f3f48059b);
$parcel$export($dbda9f692ace54dd$exports, "T400", () => $dbda9f692ace54dd$export$7c835c78b6fcdef8);
$parcel$export($dbda9f692ace54dd$exports, "T500", () => $dbda9f692ace54dd$export$6036577f95c3877e);
$parcel$export($dbda9f692ace54dd$exports, "N0", () => $dbda9f692ace54dd$export$29a4f05edc054374);
$parcel$export($dbda9f692ace54dd$exports, "N10", () => $dbda9f692ace54dd$export$e655ef011c4aa1a2);
$parcel$export($dbda9f692ace54dd$exports, "N20", () => $dbda9f692ace54dd$export$9fdfb749e33cdf97);
$parcel$export($dbda9f692ace54dd$exports, "N30", () => $dbda9f692ace54dd$export$3e51e8f1440314ba);
$parcel$export($dbda9f692ace54dd$exports, "N40", () => $dbda9f692ace54dd$export$1ce2d1575d444ceb);
$parcel$export($dbda9f692ace54dd$exports, "N50", () => $dbda9f692ace54dd$export$8754fc7e6d8b3000);
$parcel$export($dbda9f692ace54dd$exports, "N60", () => $dbda9f692ace54dd$export$c2e91cbeada39b8b);
$parcel$export($dbda9f692ace54dd$exports, "N70", () => $dbda9f692ace54dd$export$5f71e19f3a7ad9de);
$parcel$export($dbda9f692ace54dd$exports, "N80", () => $dbda9f692ace54dd$export$eaa8c8a70ac22806);
$parcel$export($dbda9f692ace54dd$exports, "N90", () => $dbda9f692ace54dd$export$7c87d337fb91a97d);
$parcel$export($dbda9f692ace54dd$exports, "N100", () => $dbda9f692ace54dd$export$d6447c357493214f);
$parcel$export($dbda9f692ace54dd$exports, "N200", () => $dbda9f692ace54dd$export$f563ee71e9ee74cd);
$parcel$export($dbda9f692ace54dd$exports, "N300", () => $dbda9f692ace54dd$export$e2ef2124cf4024b1);
$parcel$export($dbda9f692ace54dd$exports, "N400", () => $dbda9f692ace54dd$export$eece5f492e429f08);
$parcel$export($dbda9f692ace54dd$exports, "N500", () => $dbda9f692ace54dd$export$c39c0fe0f26207ae);
$parcel$export($dbda9f692ace54dd$exports, "N600", () => $dbda9f692ace54dd$export$7090862dc3038a9f);
$parcel$export($dbda9f692ace54dd$exports, "N700", () => $dbda9f692ace54dd$export$ad0bacf983b7ddaa);
$parcel$export($dbda9f692ace54dd$exports, "N800", () => $dbda9f692ace54dd$export$7d61b15e0da132af);
$parcel$export($dbda9f692ace54dd$exports, "N900", () => $dbda9f692ace54dd$export$fbda843f0a27fe96);
$parcel$export($dbda9f692ace54dd$exports, "N10A", () => $dbda9f692ace54dd$export$791e57b27ca738ef);
$parcel$export($dbda9f692ace54dd$exports, "N20A", () => $dbda9f692ace54dd$export$8d43898f60b96a82);
$parcel$export($dbda9f692ace54dd$exports, "N30A", () => $dbda9f692ace54dd$export$920c0d5c49070351);
$parcel$export($dbda9f692ace54dd$exports, "N40A", () => $dbda9f692ace54dd$export$46987b49aab6d1a8);
$parcel$export($dbda9f692ace54dd$exports, "N50A", () => $dbda9f692ace54dd$export$7d3359664e8bb0e5);
$parcel$export($dbda9f692ace54dd$exports, "N60A", () => $dbda9f692ace54dd$export$d2d3bedfb276cac0);
$parcel$export($dbda9f692ace54dd$exports, "N70A", () => $dbda9f692ace54dd$export$6e5e7499ff054f6d);
$parcel$export($dbda9f692ace54dd$exports, "N80A", () => $dbda9f692ace54dd$export$59264b346c877fa7);
$parcel$export($dbda9f692ace54dd$exports, "N90A", () => $dbda9f692ace54dd$export$d092757d7c64925c);
$parcel$export($dbda9f692ace54dd$exports, "N100A", () => $dbda9f692ace54dd$export$486ab785e4bac3c6);
$parcel$export($dbda9f692ace54dd$exports, "N200A", () => $dbda9f692ace54dd$export$fba592bbc6419fea);
$parcel$export($dbda9f692ace54dd$exports, "N300A", () => $dbda9f692ace54dd$export$13609db0e6812ab8);
$parcel$export($dbda9f692ace54dd$exports, "N400A", () => $dbda9f692ace54dd$export$fbae4efaa892d883);
$parcel$export($dbda9f692ace54dd$exports, "N500A", () => $dbda9f692ace54dd$export$f13946d26f440ce6);
$parcel$export($dbda9f692ace54dd$exports, "N600A", () => $dbda9f692ace54dd$export$19f58225ac52a306);
$parcel$export($dbda9f692ace54dd$exports, "N700A", () => $dbda9f692ace54dd$export$6384f09da70e7b62);
$parcel$export($dbda9f692ace54dd$exports, "N800A", () => $dbda9f692ace54dd$export$d0dccc730683edc2);
$parcel$export($dbda9f692ace54dd$exports, "DN900", () => $dbda9f692ace54dd$export$2f6319cf7d736c2a);
$parcel$export($dbda9f692ace54dd$exports, "DN800", () => $dbda9f692ace54dd$export$95126bc8884d6634);
$parcel$export($dbda9f692ace54dd$exports, "DN700", () => $dbda9f692ace54dd$export$8338d8c35d44ff1);
$parcel$export($dbda9f692ace54dd$exports, "DN600", () => $dbda9f692ace54dd$export$5368d76ae4fbbda7);
$parcel$export($dbda9f692ace54dd$exports, "DN500", () => $dbda9f692ace54dd$export$9f0a771d16ec8d36);
$parcel$export($dbda9f692ace54dd$exports, "DN400", () => $dbda9f692ace54dd$export$abcf8c38338b4aa5);
$parcel$export($dbda9f692ace54dd$exports, "DN300", () => $dbda9f692ace54dd$export$97e81faa16a182c7);
$parcel$export($dbda9f692ace54dd$exports, "DN200", () => $dbda9f692ace54dd$export$bfe21c59123ecf33);
$parcel$export($dbda9f692ace54dd$exports, "DN100", () => $dbda9f692ace54dd$export$ee82aa2ea6a1558);
$parcel$export($dbda9f692ace54dd$exports, "DN90", () => $dbda9f692ace54dd$export$682927c6ed76be02);
$parcel$export($dbda9f692ace54dd$exports, "DN80", () => $dbda9f692ace54dd$export$91fd9994c5be9757);
$parcel$export($dbda9f692ace54dd$exports, "DN70", () => $dbda9f692ace54dd$export$d281fbfe3cff2df6);
$parcel$export($dbda9f692ace54dd$exports, "DN60", () => $dbda9f692ace54dd$export$3902c91d8b98a753);
$parcel$export($dbda9f692ace54dd$exports, "DN50", () => $dbda9f692ace54dd$export$8e8133c1ba5845b5);
$parcel$export($dbda9f692ace54dd$exports, "DN40", () => $dbda9f692ace54dd$export$33ff357f6620b39);
$parcel$export($dbda9f692ace54dd$exports, "DN30", () => $dbda9f692ace54dd$export$633847cf062b69e0);
$parcel$export($dbda9f692ace54dd$exports, "DN20", () => $dbda9f692ace54dd$export$9776a6e503bdbf76);
$parcel$export($dbda9f692ace54dd$exports, "DN10", () => $dbda9f692ace54dd$export$6c813d5160dff5db);
$parcel$export($dbda9f692ace54dd$exports, "DN0", () => $dbda9f692ace54dd$export$3d4f271a500072a);
$parcel$export($dbda9f692ace54dd$exports, "DN800A", () => $dbda9f692ace54dd$export$fe151285c22759ec);
$parcel$export($dbda9f692ace54dd$exports, "DN700A", () => $dbda9f692ace54dd$export$a101c6190d0da34);
$parcel$export($dbda9f692ace54dd$exports, "DN600A", () => $dbda9f692ace54dd$export$4b16f52932fda51);
$parcel$export($dbda9f692ace54dd$exports, "DN500A", () => $dbda9f692ace54dd$export$a74bcd7b9845b0d8);
$parcel$export($dbda9f692ace54dd$exports, "DN400A", () => $dbda9f692ace54dd$export$9209c179316d1751);
$parcel$export($dbda9f692ace54dd$exports, "DN300A", () => $dbda9f692ace54dd$export$88f55133f636c8dd);
$parcel$export($dbda9f692ace54dd$exports, "DN200A", () => $dbda9f692ace54dd$export$51126f85d1009512);
$parcel$export($dbda9f692ace54dd$exports, "DN100A", () => $dbda9f692ace54dd$export$a069b547bd23af78);
$parcel$export($dbda9f692ace54dd$exports, "DN90A", () => $dbda9f692ace54dd$export$40cce05af3b2600a);
$parcel$export($dbda9f692ace54dd$exports, "DN80A", () => $dbda9f692ace54dd$export$b78942185925a0d);
$parcel$export($dbda9f692ace54dd$exports, "DN70A", () => $dbda9f692ace54dd$export$e058fb44b8eaafca);
$parcel$export($dbda9f692ace54dd$exports, "DN60A", () => $dbda9f692ace54dd$export$92b0b8de26920c18);
$parcel$export($dbda9f692ace54dd$exports, "DN50A", () => $dbda9f692ace54dd$export$67564f7459d3fc9e);
$parcel$export($dbda9f692ace54dd$exports, "DN40A", () => $dbda9f692ace54dd$export$77868e1ca884ffa3);
$parcel$export($dbda9f692ace54dd$exports, "DN30A", () => $dbda9f692ace54dd$export$2afd71d7d3ea2cd5);
$parcel$export($dbda9f692ace54dd$exports, "DN20A", () => $dbda9f692ace54dd$export$f2a0acaab9972c70);
$parcel$export($dbda9f692ace54dd$exports, "DN10A", () => $dbda9f692ace54dd$export$9ab70e67d6475361);
$parcel$export($dbda9f692ace54dd$exports, "T30", () => $dbda9f692ace54dd$export$d2adc5dedf09fced);
$parcel$export($dbda9f692ace54dd$exports, "L50", () => $dbda9f692ace54dd$export$f51762073d2bb381);
$parcel$export($dbda9f692ace54dd$exports, "L75", () => $dbda9f692ace54dd$export$95e26d54def96891);
// Reds
const $dbda9f692ace54dd$export$4b84fd0e2c617bd = '#FFEBE6';
const $dbda9f692ace54dd$export$b34b069eff244586 = '#FFBDAD';
const $dbda9f692ace54dd$export$be802dd0d8b57f35 = '#FF8F73';
const $dbda9f692ace54dd$export$60847d42f9da92a6 = '#FF7452';
const $dbda9f692ace54dd$export$4a7404f376229999 = '#FF5630';
const $dbda9f692ace54dd$export$2010d0fb4295b346 = '#DE350B';
const $dbda9f692ace54dd$export$2837b5a1a71d5c02 = '#BF2600';
const $dbda9f692ace54dd$export$8d9596b529bbb9cf = '#FFFAE6';
const $dbda9f692ace54dd$export$41060a744ab0b7ae = '#FFF0B3';
const $dbda9f692ace54dd$export$1cc05bbbf340e559 = '#FFE380';
const $dbda9f692ace54dd$export$5aae31392d72caaa = '#FFC400';
const $dbda9f692ace54dd$export$c6930421db9fa514 = '#FFAB00';
const $dbda9f692ace54dd$export$59619663aa6500fb = '#FF991F';
const $dbda9f692ace54dd$export$874739ea9e379ab6 = '#FF8B00';
const $dbda9f692ace54dd$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dbda9f692ace54dd$export$69a3bf21b9686c2b = '#ABF5D1';
const $dbda9f692ace54dd$export$afbce1382ec95f73 = '#79F2C0';
const $dbda9f692ace54dd$export$747d86715d4175de = '#57D9A3';
const $dbda9f692ace54dd$export$940e1f69e873f202 = '#36B37E';
const $dbda9f692ace54dd$export$a49394138f7b8e85 = '#00875A';
const $dbda9f692ace54dd$export$6fa04827ac68a4fb = '#006644';
const $dbda9f692ace54dd$export$226de0355ed012f8 = '#DEEBFF';
const $dbda9f692ace54dd$export$8c13c2ee36917869 = '#B3D4FF';
const $dbda9f692ace54dd$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dbda9f692ace54dd$export$215b7063051591f1 = '#2684FF';
const $dbda9f692ace54dd$export$e62e8919cca44969 = '#0065FF';
const $dbda9f692ace54dd$export$b3de0ae08da2ce64 = '#0052CC';
const $dbda9f692ace54dd$export$a6ee3d71bc067634 = '#0747A6';
const $dbda9f692ace54dd$export$67f15409e87642a1 = '#669DF1';
const $dbda9f692ace54dd$export$f0539dbc42dbb067 = '#8FB8F6';
const $dbda9f692ace54dd$export$363e4475840015bb = '#EAE6FF';
const $dbda9f692ace54dd$export$4b0a4417ed59760f = '#C0B6F2';
const $dbda9f692ace54dd$export$6011520a64d9a187 = '#998DD9';
const $dbda9f692ace54dd$export$a7175d4e9206bc80 = '#8777D9';
const $dbda9f692ace54dd$export$b48405b95304b5a1 = '#6554C0';
const $dbda9f692ace54dd$export$c71e4279dd54a18d = '#5243AA';
const $dbda9f692ace54dd$export$147899de772240ec = '#403294';
const $dbda9f692ace54dd$export$2cf711fe14c66f06 = '#E6FCFF';
const $dbda9f692ace54dd$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dbda9f692ace54dd$export$776c9c497ef08533 = '#79E2F2';
const $dbda9f692ace54dd$export$69cb3ca10c1e330e = '#00C7E6';
const $dbda9f692ace54dd$export$9dc1ef0f3f48059b = '#00B8D9';
const $dbda9f692ace54dd$export$7c835c78b6fcdef8 = '#00A3BF';
const $dbda9f692ace54dd$export$6036577f95c3877e = '#008DA6';
const $dbda9f692ace54dd$export$29a4f05edc054374 = '#FFFFFF';
const $dbda9f692ace54dd$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dbda9f692ace54dd$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dbda9f692ace54dd$export$3e51e8f1440314ba = '#EBECF0';
const $dbda9f692ace54dd$export$1ce2d1575d444ceb = '#DFE1E6';
const $dbda9f692ace54dd$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dbda9f692ace54dd$export$c2e91cbeada39b8b = '#B3BAC5';
const $dbda9f692ace54dd$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dbda9f692ace54dd$export$eaa8c8a70ac22806 = '#97A0AF';
const $dbda9f692ace54dd$export$7c87d337fb91a97d = '#8993A4';
const $dbda9f692ace54dd$export$d6447c357493214f = '#7A869A';
const $dbda9f692ace54dd$export$f563ee71e9ee74cd = '#6B778C';
const $dbda9f692ace54dd$export$e2ef2124cf4024b1 = '#5E6C84';
const $dbda9f692ace54dd$export$eece5f492e429f08 = '#505F79';
const $dbda9f692ace54dd$export$c39c0fe0f26207ae = '#42526E';
const $dbda9f692ace54dd$export$7090862dc3038a9f = '#344563';
const $dbda9f692ace54dd$export$ad0bacf983b7ddaa = '#253858';
const $dbda9f692ace54dd$export$7d61b15e0da132af = '#172B4D';
const $dbda9f692ace54dd$export$fbda843f0a27fe96 = '#091E42';
const $dbda9f692ace54dd$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dbda9f692ace54dd$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dbda9f692ace54dd$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dbda9f692ace54dd$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dbda9f692ace54dd$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dbda9f692ace54dd$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dbda9f692ace54dd$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dbda9f692ace54dd$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dbda9f692ace54dd$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dbda9f692ace54dd$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dbda9f692ace54dd$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dbda9f692ace54dd$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dbda9f692ace54dd$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dbda9f692ace54dd$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dbda9f692ace54dd$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dbda9f692ace54dd$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dbda9f692ace54dd$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dbda9f692ace54dd$export$2f6319cf7d736c2a = '#E6EDFA';
const $dbda9f692ace54dd$export$95126bc8884d6634 = '#DCE5F5';
const $dbda9f692ace54dd$export$8338d8c35d44ff1 = '#CED9EB';
const $dbda9f692ace54dd$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dbda9f692ace54dd$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dbda9f692ace54dd$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dbda9f692ace54dd$export$97e81faa16a182c7 = '#8C9CB8';
const $dbda9f692ace54dd$export$bfe21c59123ecf33 = '#7988A3';
const $dbda9f692ace54dd$export$ee82aa2ea6a1558 = '#67758F';
const $dbda9f692ace54dd$export$682927c6ed76be02 = '#56637A';
const $dbda9f692ace54dd$export$91fd9994c5be9757 = '#455166';
const $dbda9f692ace54dd$export$d281fbfe3cff2df6 = '#3B475C';
const $dbda9f692ace54dd$export$3902c91d8b98a753 = '#313D52';
const $dbda9f692ace54dd$export$8e8133c1ba5845b5 = '#283447';
const $dbda9f692ace54dd$export$33ff357f6620b39 = '#202B3D';
const $dbda9f692ace54dd$export$633847cf062b69e0 = '#1B2638';
const $dbda9f692ace54dd$export$9776a6e503bdbf76 = '#121A29';
const $dbda9f692ace54dd$export$6c813d5160dff5db = '#0E1624';
const $dbda9f692ace54dd$export$3d4f271a500072a = '#0D1424';
const $dbda9f692ace54dd$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dbda9f692ace54dd$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dbda9f692ace54dd$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dbda9f692ace54dd$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dbda9f692ace54dd$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dbda9f692ace54dd$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dbda9f692ace54dd$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dbda9f692ace54dd$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dbda9f692ace54dd$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dbda9f692ace54dd$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dbda9f692ace54dd$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dbda9f692ace54dd$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dbda9f692ace54dd$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dbda9f692ace54dd$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dbda9f692ace54dd$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dbda9f692ace54dd$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dbda9f692ace54dd$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dbda9f692ace54dd$export$d2adc5dedf09fced = '#292A2E';
const $dbda9f692ace54dd$export$f51762073d2bb381 = '#94C748';
const $dbda9f692ace54dd$export$95e26d54def96891 = '#B3DF72';

parcelRegister("42CYN", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $b40792da90aac98f$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $b40792da90aac98f$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $b40792da90aac98f$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $b40792da90aac98f$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $b40792da90aac98f$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $b40792da90aac98f$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $b40792da90aac98f$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $b40792da90aac98f$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $b40792da90aac98f$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $b40792da90aac98f$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $b40792da90aac98f$export$be3c814f7ed506ed);

const $b40792da90aac98f$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`;
const $b40792da90aac98f$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $dbda9f692ace54dd$export$a6ee3d71bc067634)})`;
const $b40792da90aac98f$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$8754fc7e6d8b3000)})`;
const $b40792da90aac98f$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $dbda9f692ace54dd$export$3e51e8f1440314ba)})`;
const $b40792da90aac98f$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $dbda9f692ace54dd$export$29a4f05edc054374)})`;
const $b40792da90aac98f$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $dbda9f692ace54dd$export$9fdfb749e33cdf97)})`;
const $b40792da90aac98f$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$c39c0fe0f26207ae)})`;
const $b40792da90aac98f$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$c2e91cbeada39b8b)})`;
const $b40792da90aac98f$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $dbda9f692ace54dd$export$7c87d337fb91a97d)})`;
const $b40792da90aac98f$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $dbda9f692ace54dd$export$7d61b15e0da132af)})`;
const $b40792da90aac98f$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $dbda9f692ace54dd$export$7c87d337fb91a97d)})`;

});

parcelRegister("bVk6D", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $05f8cc3dcdaf6646$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5JBkS = parcelRequire("5JBkS");
const $05f8cc3dcdaf6646$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $05f8cc3dcdaf6646$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const imgRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
        ref: containerRef,
        xcss: $05f8cc3dcdaf6646$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5JBkS.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $05f8cc3dcdaf6646$var$styles.image
        })
    });
};

});





parcelRegister("7I2zi", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $9d3ef40360103f2e$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $9d3ef40360103f2e$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $9d3ef40360103f2e$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $9d3ef40360103f2e$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $9d3ef40360103f2e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $9d3ef40360103f2e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $9d3ef40360103f2e$export$518f47d656cb4e1a);

var $8zOmE = parcelRequire("8zOmE");

var $8vYX2 = parcelRequire("8vYX2");

const $9d3ef40360103f2e$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $9d3ef40360103f2e$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $9d3ef40360103f2e$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $9d3ef40360103f2e$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $9d3ef40360103f2e$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($9d3ef40360103f2e$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $8zOmE.fireScreenAnalytics)(analyticsEvent);
    }
};
const $9d3ef40360103f2e$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $9d3ef40360103f2e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $9d3ef40360103f2e$var$getSpaViewProfileAction = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $9d3ef40360103f2e$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$export$518f47d656cb4e1a = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $e6a2e0952e4731b8$export$23cedd3261bd8015:
                return $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup);
            case 0, $e6a2e0952e4731b8$export$6bef782d14a92db8:
                return $9d3ef40360103f2e$var$getAssignedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$6b36f20db7a18a86:
                return $9d3ef40360103f2e$var$getReportedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$56da0dd0b0aa67b9:
                return $9d3ef40360103f2e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("8vYX2", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $a3966562156ba1e4$export$49f2d2ccb123fddf);

var $7VHMR = parcelRequire("7VHMR");
const $a3966562156ba1e4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $a3966562156ba1e4$export$49f2d2ccb123fddf = (0, $7VHMR.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});

const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';


parcelRegister("f5xXn", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $05053b3a38034fd2$export$59abd6feb7dc8540);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $4oO9d = parcelRequire("4oO9d");

var $gLmUz = parcelRequire("gLmUz");

var $cSD7y = parcelRequire("cSD7y");

var $9l5Jv = parcelRequire("9l5Jv");
const $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    const orgId = (0, $4oO9d.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$export$59abd6feb7dc8540 = (0, $cSD7y.componentWithFG)('issue_view_prevent_unnecessary_orgid_query', $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId, $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId);

});
parcelRegister("4oO9d", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $554c0ec604398cd6$export$52a03a3207af3687);

var $9OXo1 = parcelRequire("9OXo1");
const $554c0ec604398cd6$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("gLmUz", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $53e785fb2e37b84f$export$cb9379d435214a54);

var $9OXo1 = parcelRequire("9OXo1");
const $53e785fb2e37b84f$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("9l5Jv", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $85b7b963f4e84597$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $85b7b963f4e84597$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $85b7b963f4e84597$export$d43dc22a8337ee9f);

var $6SmO2 = parcelRequire("6SmO2");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $58UyI = parcelRequire("58UyI");
const $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, _orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $6SmO2.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $6SmO2.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$export$c4393c51e6d104c3 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query'), $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId, $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId);
const $85b7b963f4e84597$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            if ((0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query')) {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
                setState({
                    profileClient: finalProfileClient
                });
            } else {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId);
                setState({
                    profileClient: finalProfileClient
                });
            }
        }
};
const $85b7b963f4e84597$export$d816ba2709570028 = (0, $gg7kZ.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $85b7b963f4e84597$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $85b7b963f4e84597$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ProfileClientStore',
    initialState: $85b7b963f4e84597$export$d4c72bab9d6cc13a,
    actions: $85b7b963f4e84597$export$e324594224ef24da,
    containedBy: $85b7b963f4e84597$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($85b7b963f4e84597$export$e324594224ef24da.bootstrap())
    }
});
const $85b7b963f4e84597$export$d43dc22a8337ee9f = (0, $3sQ5x.createStateHook)($85b7b963f4e84597$export$6f57813fe9f31bf9);

});
parcelRegister("6SmO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f55c7ac4739f7dc5$export$2e2bcd8739ae039);


var $faEOG = parcelRequire("faEOG");


var $4Hp8Y = parcelRequire("4Hp8Y");
var $f55c7ac4739f7dc5$export$2e2bcd8739ae039 = (0, $faEOG.default);

});
parcelRegister("faEOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a98206c52d65b36$export$2e2bcd8739ae039);

var $in8kY = parcelRequire("in8kY");
var $iO7ih = parcelRequire("iO7ih");

var $kitvH = parcelRequire("kitvH");

var $6Mr2k = parcelRequire("6Mr2k");

var $1O3rH = parcelRequire("1O3rH");

var $4Hp8Y = parcelRequire("4Hp8Y");
const $7a98206c52d65b36$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $7a98206c52d65b36$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$7a98206c52d65b36$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $7a98206c52d65b36$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $4Hp8Y.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $1O3rH.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $kitvH.default)(withDefaultConfig);
        this.tcClient = $7a98206c52d65b36$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $in8kY.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $in8kY.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $7a98206c52d65b36$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $iO7ih.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $6Mr2k.default)({
        ...config
    }) : undefined;
}
var $7a98206c52d65b36$export$2e2bcd8739ae039 = $7a98206c52d65b36$var$ProfileCardClient;

});
parcelRegister("kitvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c320c5764f1d53d6$export$2e2bcd8739ae039);

var $lL6Xv = parcelRequire("lL6Xv");

var $f0Crb = parcelRequire("f0Crb");

var $9Fyhb = parcelRequire("9Fyhb");

var $g6ogF = parcelRequire("g6ogF");
const $c320c5764f1d53d6$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $c320c5764f1d53d6$export$2e2bcd8739ae039 extends (0, $9Fyhb.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $c320c5764f1d53d6$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('triggered'));
            const headers = $c320c5764f1d53d6$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $c320c5764f1d53d6$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $lL6Xv.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $lL6Xv.agentRequestAnalytics)('triggered'));
            const headers = $c320c5764f1d53d6$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $lL6Xv.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $lL6Xv.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("9Fyhb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c4c83d4275dd5f$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $d6c4c83d4275dd5f$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("g6ogF", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d119430acb2c1eb7$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d119430acb2c1eb7$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d119430acb2c1eb7$export$d9ad65d422ee3f8c);

var $faJFy = parcelRequire("faJFy");
const $d119430acb2c1eb7$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d119430acb2c1eb7$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d119430acb2c1eb7$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d119430acb2c1eb7$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $faJFy.DirectoryGraphQLError)) return !!error && $d119430acb2c1eb7$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $faJFy.AGGError)) return !!error.errorType && $d119430acb2c1eb7$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d119430acb2c1eb7$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d119430acb2c1eb7$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $faJFy.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d119430acb2c1eb7$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d119430acb2c1eb7$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $faJFy.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d119430acb2c1eb7$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $faJFy.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d119430acb2c1eb7$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d119430acb2c1eb7$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $faJFy.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d119430acb2c1eb7$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $faJFy.DirectoryGraphQLErrors) || causeError instanceof (0, $faJFy.AGGErrors)) return $d119430acb2c1eb7$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d119430acb2c1eb7$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $faJFy.DirectoryGraphQLErrors)(errors, traceId);
};
const $d119430acb2c1eb7$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $faJFy.AGGErrors)(errors, traceId);
};

});
parcelRegister("faJFy", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $0210b89cb6f674a7$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $0210b89cb6f674a7$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $0210b89cb6f674a7$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $0210b89cb6f674a7$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $0210b89cb6f674a7$export$60d8267243755b9c);
class $0210b89cb6f674a7$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $0210b89cb6f674a7$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $0210b89cb6f674a7$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $0210b89cb6f674a7$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $0210b89cb6f674a7$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $0210b89cb6f674a7$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $0210b89cb6f674a7$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("6Mr2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c84d5f37ee59c9b$export$2e2bcd8739ae039);

var $hFKXd = parcelRequire("hFKXd");

var $9Fyhb = parcelRequire("9Fyhb");

var $fCR0Z = parcelRequire("fCR0Z");

var $5teE1 = parcelRequire("5teE1");
const $1c84d5f37ee59c9b$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $1c84d5f37ee59c9b$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $1c84d5f37ee59c9b$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $1c84d5f37ee59c9b$var$orgIdPromiseCache = new Map();
const $1c84d5f37ee59c9b$var$workspaceExistsWithTypePromiseCache = new Map();
class $1c84d5f37ee59c9b$var$TeamCentralCardClient extends (0, $9Fyhb.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $1c84d5f37ee59c9b$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $1c84d5f37ee59c9b$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $1c84d5f37ee59c9b$export$1862ef0c3880ca8d(userId);
        const response = await (0, $5teE1.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $hFKXd.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $1c84d5f37ee59c9b$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $1c84d5f37ee59c9b$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $hFKXd.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $1c84d5f37ee59c9b$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $1c84d5f37ee59c9b$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $fCR0Z.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $1c84d5f37ee59c9b$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $1c84d5f37ee59c9b$export$2e2bcd8739ae039 = $1c84d5f37ee59c9b$var$TeamCentralCardClient;

});
parcelRegister("fCR0Z", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $fe0c71ee1bb20dae$export$d38a536fd806c68f);

var $5teE1 = parcelRequire("5teE1");
const $fe0c71ee1bb20dae$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $fe0c71ee1bb20dae$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $fe0c71ee1bb20dae$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $fe0c71ee1bb20dae$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $5teE1.AGGQuery)(url, query, $fe0c71ee1bb20dae$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("5teE1", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $af1179d516dcb8b6$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $af1179d516dcb8b6$export$a14afb5f82fe705);

var $faJFy = parcelRequire("faJFy");

var $g6ogF = parcelRequire("g6ogF");
const $af1179d516dcb8b6$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $af1179d516dcb8b6$var$id = (headers)=>headers;
async function $af1179d516dcb8b6$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $af1179d516dcb8b6$var$id) {
    return $af1179d516dcb8b6$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $g6ogF.handleDirectoryGraphQLErrors));
}
async function $af1179d516dcb8b6$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $af1179d516dcb8b6$var$id) {
    return $af1179d516dcb8b6$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $g6ogF.handleAGGErrors));
}
async function $af1179d516dcb8b6$var$graphQLQuery(serviceUrl, query, processHeaders = $af1179d516dcb8b6$var$id, handleErrors) {
    const headers = processHeaders($af1179d516dcb8b6$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $faJFy.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("1O3rH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1953a7f9d6f1cc$export$2e2bcd8739ae039);

var $lL6Xv = parcelRequire("lL6Xv");

var $f0Crb = parcelRequire("f0Crb");

var $9Fyhb = parcelRequire("9Fyhb");

var $g6ogF = parcelRequire("g6ogF");

var $eXjT6 = parcelRequire("eXjT6");
class $4b1953a7f9d6f1cc$export$2e2bcd8739ae039 extends (0, $9Fyhb.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $eXjT6.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            if (analytics) analytics((0, $lL6Xv.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $lL6Xv.teamRequestAnalytics)('succeeded', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $lL6Xv.teamRequestAnalytics)('failed', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("eXjT6", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $3a68f2beaedadac6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $3a68f2beaedadac6$export$26a8aad0c7182dd6);

var $hFKXd = parcelRequire("hFKXd");

var $5teE1 = parcelRequire("5teE1");
const $3a68f2beaedadac6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $3a68f2beaedadac6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $3a68f2beaedadac6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $3a68f2beaedadac6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($3a68f2beaedadac6$var$ARI_PREFIX) ? teamIdOrTeamAri : $3a68f2beaedadac6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $3a68f2beaedadac6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $3a68f2beaedadac6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $3a68f2beaedadac6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $3a68f2beaedadac6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$3a68f2beaedadac6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $3a68f2beaedadac6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $3a68f2beaedadac6$export$4968f4e0119a5d9c,
        variables: {
            teamId: (0, $hFKXd.fg)('team_id_to_ari_safe') ? $3a68f2beaedadac6$export$7878e28c136af76(teamId) : $3a68f2beaedadac6$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $3a68f2beaedadac6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $3a68f2beaedadac6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $3a68f2beaedadac6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $5teE1.AGGQuery)(url, query, $3a68f2beaedadac6$export$1229c72526c01df2);
    return $3a68f2beaedadac6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("4Hp8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d6eee5f6f8bd7d$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $hFKXd = parcelRequire("hFKXd");

var $lL6Xv = parcelRequire("lL6Xv");

var $bVK3w = parcelRequire("bVK3w");

var $f0Crb = parcelRequire("f0Crb");

var $9Fyhb = parcelRequire("9Fyhb");

var $g6ogF = parcelRequire("g6ogF");

var $5teE1 = parcelRequire("5teE1");
const $d1d6eee5f6f8bd7d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $d1d6eee5f6f8bd7d$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $d1d6eee5f6f8bd7d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $d1d6eee5f6f8bd7d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $hFKXd.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($d1d6eee5f6f8bd7d$var$aggUserQuery) : $d1d6eee5f6f8bd7d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $d1d6eee5f6f8bd7d$var$queryAGGUser = async (url, userId)=>{
    const query = $d1d6eee5f6f8bd7d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $5teE1.AGGQuery)(url, query);
    return user;
};
class $d1d6eee5f6f8bd7d$export$2e2bcd8739ae039 extends (0, $9Fyhb.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $d1d6eee5f6f8bd7d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $bVK3w.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $bVK3w.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $bVK3w.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $f0Crb.getPageTime)();
            if (analytics) analytics((0, $lL6Xv.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $lL6Xv.userRequestAnalytics)('succeeded', {
                    duration: (0, $f0Crb.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $lL6Xv.userRequestAnalytics)('failed', {
                    duration: (0, $f0Crb.getPageTime)() - startTime,
                    ...(0, $g6ogF.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("bVK3w", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $c8012f47134731bd$export$f0dfd716e7b023cd);
parcelRequire("jbvTU");
var $lY0d6 = parcelRequire("lY0d6");
const $c8012f47134731bd$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $lY0d6.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("jbvTU", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("lY0d6")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $lY0d6 = parcelRequire("lY0d6");





});
parcelRegister("lY0d6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffdf5d5b58b30bc3$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $9P2Or = parcelRequire("9P2Or");

var $bVkMP = parcelRequire("bVkMP");
function $ffdf5d5b58b30bc3$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $9P2Or.default)((0, $bVkMP.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("9P2Or", function(module, exports) {

$parcel$export(module.exports, "default", () => $726b0ef96dab6877$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $i1uJj = parcelRequire("i1uJj");

var $fQECm = parcelRequire("fQECm");
var $726b0ef96dab6877$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $726b0ef96dab6877$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($726b0ef96dab6877$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $fQECm.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $i1uJj.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("i1uJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0362d75bff1a8bd1$export$2e2bcd8739ae039);

var $5YXEL = parcelRequire("5YXEL");

var $47ZoC = parcelRequire("47ZoC");
var $0362d75bff1a8bd1$var$MILLISECONDS_IN_MINUTE = 60000;
var $0362d75bff1a8bd1$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $0362d75bff1a8bd1$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $0362d75bff1a8bd1$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $0362d75bff1a8bd1$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $0362d75bff1a8bd1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $0362d75bff1a8bd1$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $0362d75bff1a8bd1$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $0362d75bff1a8bd1$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $0362d75bff1a8bd1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $0362d75bff1a8bd1$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $0362d75bff1a8bd1$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $0362d75bff1a8bd1$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $5YXEL.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $5YXEL.default)('long', date, options);
        }
    }
};
function $0362d75bff1a8bd1$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $47ZoC.default)(timeZone, originalDate, true) / $0362d75bff1a8bd1$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $0362d75bff1a8bd1$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $0362d75bff1a8bd1$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $0362d75bff1a8bd1$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $0362d75bff1a8bd1$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $0362d75bff1a8bd1$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $0362d75bff1a8bd1$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $0362d75bff1a8bd1$var$formatTimezone(offset, dirtyDelimeter);
}
function $0362d75bff1a8bd1$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $0362d75bff1a8bd1$var$addLeadingZeros(minutes, 2);
}
var $0362d75bff1a8bd1$export$2e2bcd8739ae039 = $0362d75bff1a8bd1$var$formatters;

});
parcelRegister("5YXEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b0d4dc9f480f72$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $45b0d4dc9f480f72$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $45b0d4dc9f480f72$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $45b0d4dc9f480f72$var$partsTimeZone(dtf, date) : $45b0d4dc9f480f72$var$hackyTimeZone(dtf, date);
}
function $45b0d4dc9f480f72$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $45b0d4dc9f480f72$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $45b0d4dc9f480f72$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("47ZoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $301770e0177fd956$export$2e2bcd8739ae039);

var $gwK5m = parcelRequire("gwK5m");

var $9ZOPi = parcelRequire("9ZOPi");
var $301770e0177fd956$var$MILLISECONDS_IN_HOUR = 3600000;
var $301770e0177fd956$var$MILLISECONDS_IN_MINUTE = 60000;
var $301770e0177fd956$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $301770e0177fd956$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $301770e0177fd956$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $301770e0177fd956$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$301770e0177fd956$var$validateTimezone(hours)) return NaN;
        return -(hours * $301770e0177fd956$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $301770e0177fd956$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$301770e0177fd956$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $301770e0177fd956$var$MILLISECONDS_IN_HOUR + minutes * $301770e0177fd956$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($301770e0177fd956$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $301770e0177fd956$var$toUtcDate(date);
        var offset = $301770e0177fd956$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $301770e0177fd956$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $301770e0177fd956$var$toUtcDate(date) {
    return (0, $9ZOPi.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $301770e0177fd956$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gwK5m.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $9ZOPi.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $301770e0177fd956$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $301770e0177fd956$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $301770e0177fd956$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $301770e0177fd956$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $301770e0177fd956$var$validIANATimezoneCache = {};
function $301770e0177fd956$var$isValidTimezoneIANAString(timeZoneString) {
    if ($301770e0177fd956$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $301770e0177fd956$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gwK5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $c083621ab6bd8f25$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c083621ab6bd8f25$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c083621ab6bd8f25$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c083621ab6bd8f25$var$partsOffset(dtf, date) : $c083621ab6bd8f25$var$hackyOffset(dtf, date);
}
var $c083621ab6bd8f25$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c083621ab6bd8f25$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c083621ab6bd8f25$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c083621ab6bd8f25$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c083621ab6bd8f25$var$dtfCache = {};
function $c083621ab6bd8f25$var$getDateTimeFormat(timeZone) {
    if (!$c083621ab6bd8f25$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c083621ab6bd8f25$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c083621ab6bd8f25$var$dtfCache[timeZone];
}

});

parcelRegister("9ZOPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $74713c993ce38280$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $74713c993ce38280$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("fQECm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89b382e39d8e7f3$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $47ZoC = parcelRequire("47ZoC");

var $66slO = parcelRequire("66slO");
var $b89b382e39d8e7f3$var$MILLISECONDS_IN_HOUR = 3600000;
var $b89b382e39d8e7f3$var$MILLISECONDS_IN_MINUTE = 60000;
var $b89b382e39d8e7f3$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $b89b382e39d8e7f3$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $66slO.default)
};
function $b89b382e39d8e7f3$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $b89b382e39d8e7f3$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $b89b382e39d8e7f3$var$splitDateString(argument);
    var parseYearResult = $b89b382e39d8e7f3$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $b89b382e39d8e7f3$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $b89b382e39d8e7f3$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $47ZoC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $b89b382e39d8e7f3$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $b89b382e39d8e7f3$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $b89b382e39d8e7f3$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $b89b382e39d8e7f3$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b89b382e39d8e7f3$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $b89b382e39d8e7f3$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $b89b382e39d8e7f3$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $b89b382e39d8e7f3$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $b89b382e39d8e7f3$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $b89b382e39d8e7f3$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $b89b382e39d8e7f3$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$b89b382e39d8e7f3$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $b89b382e39d8e7f3$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$b89b382e39d8e7f3$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $b89b382e39d8e7f3$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$b89b382e39d8e7f3$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $b89b382e39d8e7f3$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$b89b382e39d8e7f3$var$validateWeekDate(year, week)) return new Date(NaN);
        return $b89b382e39d8e7f3$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $b89b382e39d8e7f3$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$b89b382e39d8e7f3$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b89b382e39d8e7f3$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $b89b382e39d8e7f3$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $b89b382e39d8e7f3$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$b89b382e39d8e7f3$var$validateTime(hours)) return NaN;
        return hours % 24 * $b89b382e39d8e7f3$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $b89b382e39d8e7f3$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$b89b382e39d8e7f3$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $b89b382e39d8e7f3$var$MILLISECONDS_IN_HOUR + minutes * $b89b382e39d8e7f3$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $b89b382e39d8e7f3$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$b89b382e39d8e7f3$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $b89b382e39d8e7f3$var$MILLISECONDS_IN_HOUR + minutes * $b89b382e39d8e7f3$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $b89b382e39d8e7f3$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $b89b382e39d8e7f3$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $b89b382e39d8e7f3$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b89b382e39d8e7f3$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b89b382e39d8e7f3$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $b89b382e39d8e7f3$var$isLeapYearIndex(year);
        if (isLeapYear && date > $b89b382e39d8e7f3$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $b89b382e39d8e7f3$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $b89b382e39d8e7f3$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $b89b382e39d8e7f3$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $b89b382e39d8e7f3$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $b89b382e39d8e7f3$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("66slO", function(module, exports) {

$parcel$export(module.exports, "default", () => $47194b7c9a3055bb$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $47194b7c9a3055bb$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $47194b7c9a3055bb$export$2e2bcd8739ae039 = $47194b7c9a3055bb$var$tzPattern;

});



parcelRegister("bVkMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae5245d8a6cee90$export$2e2bcd8739ae039);

var $47ZoC = parcelRequire("47ZoC");

var $fQECm = parcelRequire("fQECm");
function $8ae5245d8a6cee90$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $fQECm.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $47ZoC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("58UyI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $2fe94d89052b4b13$export$4b2a86afb64f42f1);

var $4Hp8Y = parcelRequire("4Hp8Y");

var $7f4tk = parcelRequire("7f4tk");

var $7I2zi = parcelRequire("7I2zi");
class $2fe94d89052b4b13$export$4b2a86afb64f42f1 extends (0, $4Hp8Y.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $7I2zi.isCustomerAccount)(userId)) {
                    const response = await (0, $7f4tk.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $7I2zi.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});





//# sourceMappingURL=async-team-profilecard-next.3b051d0c.js.map
